import React from 'react';
import GitHubIcon from '@mui/icons-material/GitHub';

import OpenInNewIcon from '@mui/icons-material/OpenInNew';

import '../service/card.css';
import { AnimatedOnScroll } from 'react-animated-css-onscroll';

const Card = ({ image, cardTitle, body, gitHub, visit }) => {
	return (
		<AnimatedOnScroll animationIn="fadeInDownBig">
			<div class="card">
				<img
					// className="images-capture"
					src={image}
					alt="sync app"
					width="350"
					height="290"></img>

				<div class="card__content">
					<p class="card__title">{cardTitle}</p>
					<p class="card__description">{body}</p>
					<h1 style={{ marginTop: '15px', gap: '10px' }}>
						<a href={gitHub}>
							<GitHubIcon
								sx={{
									padding: '5px',
									borderRadius: '2px',
									fontSize: '35px',
									color: '#BC379E',
									cursor: 'pointer',
								}}
							/>
						</a>
						<a href={visit}>
							<OpenInNewIcon
								sx={{
									background: '#BC379E',
									padding: '5px',
									borderRadius: '2px',
									fontSize: '35px',
									color: 'white',
									cursor: 'pointer',
									marginLeft: '7px',
								}}
							/>
						</a>
					</h1>
				</div>
			</div>
		</AnimatedOnScroll>
	);
};

export default Card;
